var stepByStep = (function () {
    var form = $("#car-detail-quote-request form");
    var $btnSubmit = $('.form-preventivo button.main-submit-btn');
    var hasCarDetails = true;
    function init() {
        $(document).ready(function () {
            managePMEform();
            manageCustomerType();
            managePrivacyConsent();
            form.find("select[name=customer_type]").trigger('change');
            if (form.length){
                setCampaignFromLocalStorage();
            }
            $('.tooltip-button').tooltip();
            var errorBox = $(".form-custom:not(.customizable-contact-form) .container.form-container-error");
            errorBox.hide();

            $btnSubmit.on("click", function (e) {
                var isValid = formIsValid();
                if(!isValid) {
                    e.preventDefault();
                    firstErrorField();
                    scrollToTopForm();
                } else{
                    if($(".form-preventivo #recaptcha").length > 0) {
                        grecaptcha.execute();
                    }
                }

                /*if (isValid && !isLast) {
                    goNextStep();
                }*/
            });
            showErrors();
            helper();
        });
    }

    function firstErrorField() {
        var fields = $("input.form-control, input.form-check-input, select.form-control", form);
        if (fields.length) {
            var firstInvalid = fields.first();
            firstInvalid.focus();
        }
    }

    function setCampaignFromLocalStorage(){
        var utm_params = utmParametersManager.getUtmParametersFromStorage();
        var campaignContent = $('[name="campaignContent"]');
        var campaignMedium = $('[name="campaignMedium"]');
        var campaignSource = $('[name="campaignSource"]');
        var campaignName = $('[name="campaignName"]');
        var campaignTermGoogleAnalytics = $('[name="campaignTermGoogleAnalytics"]');
        if (utm_params !== null){
            if (campaignContent.length){
                campaignContent.val(utm_params.utm_content)
            }
            if (campaignMedium.length){
                campaignMedium.val(utm_params.utm_medium)
            }
            if (campaignSource.length){
                campaignSource.val(utm_params.utm_source)
            }
            if (campaignName.length){
                campaignName.val(utm_params.utm_campaign)
            }
            if (campaignTermGoogleAnalytics.length){
                campaignTermGoogleAnalytics.val(utm_params.utm_term)
            }
        }
    }

    function scrollToTopForm() {
        var header = $(".nav-main");
        var nav = $(".nav-top");
        var offerSticky = $(".offer-sticky");
        var errorMessage = $(".form-container-error");
        var extraHeight = 0;
        if (header.length && nav.length && offerSticky.length) {
            extraHeight = header.outerHeight()+nav.outerHeight()+offerSticky.outerHeight();
        }

        if(errorMessage.length){
            $('html, body').animate({
                scrollTop: errorMessage.offset().top-150
            }, 1500);
        }


    }

    function managePrivacyConsent() {
        var consentButtonsContainer = $('.main-quote-request-form #privacyCustomFeedback .radio-container:not(.d-none)', form);
        if (consentButtonsContainer.length>0){
            var invalidFeedback = consentButtonsContainer.closest('fieldset').find('.invalid-feedback');
            $('#field-privacy-Y', consentButtonsContainer).on('click', function (event) {
                invalidFeedback.addClass('d-none').removeClass('d-block');
                consentButtonsContainer.removeClass('is-invalid');
            })
            $('#field-privacy-N', consentButtonsContainer).on('click', function (event) {
                invalidFeedback.removeClass('d-none').addClass('d-block');
                consentButtonsContainer.addClass('is-invalid');
            })
        }
    }

    function managePMEform() {
        $(".pme [name=fleet_elements]").on("change", function () {
            var fieldToDisable = $("[name=offer_model], [name=offer_months], [name=offer_km]");
            if ($(this).val() === '0-3') {
                hasCarDetails = true;
                fieldToDisable.prop("disabled", false)
                    .removeClass('disabled');
                $.each(fieldToDisable, function () {
                    $(this).attr("data-validate-required", true)
                });
                $(this).closest('.main-quote-request-form').removeClass('no-car-details')
            } else {
                hasCarDetails = false;
                fieldToDisable.prop("disabled", true)
                    .addClass('disabled');
                $.each(fieldToDisable, function () {
                    $(this).attr("data-validate-required", false)
                });
                $(this).closest('.main-quote-request-form').addClass('no-car-details')
            }
        });
    }

    function manageCustomerType() {
        if ($('[name=customer_type]').val() == 'private'){
            $("[name=fleet_elements]").closest('.col-sm-6').addClass('d-none');
            $("[name=fleet_elements]").closest('.col-12').addClass('d-none');
            $("[name=fleet_elements]").attr("data-validate-required", false);
        }
        if ($('[name=customer_type]').val() == 'professional' || $('[name=customer_type]').val() == 'corporate'){
            $("select[name=customer_type]").trigger('change');
        }
        $("select[name=customer_type]").on("change", function () {
            var sectionsToRemove = ['.formBtnWrapper','.mandatory-label','.offer-container:not(.special-case)','.userInfo-container fieldset:not(.target-row):not(.campaign-target-row)','.container.consents-container'];
            var mainQuoteRequestForm = $('#car-detail-quote-request .form-container .main-quote-request-form');
            var alternativeTargetSnippet = mainQuoteRequestForm.find('.container.alternative-target-snippet');
            var alternativeCustomSnippet = '.alternative-snippet-'+$(this, mainQuoteRequestForm).val()

            // search if alternative snippet is enabled for selected target
            // yes -> replaces form with snippet
            // no -> shows the forms and the snippet (if shown) gets hidden
            if (alternativeTargetSnippet.length>0 && alternativeTargetSnippet.find(alternativeCustomSnippet).length>0){
                alternativeTargetSnippet.find('.row:not('+alternativeCustomSnippet+')').addClass('d-none');
                alternativeTargetSnippet.removeClass('d-none');
                alternativeTargetSnippet.find(alternativeCustomSnippet).removeClass('d-none');
                sectionsToRemove.forEach((classToRemove) => {
                    mainQuoteRequestForm.find(classToRemove).addClass('d-none');
                })
            }else if(alternativeTargetSnippet.length===0 || alternativeTargetSnippet.find(alternativeCustomSnippet).length===0) {
                alternativeTargetSnippet.addClass('d-none');
                alternativeTargetSnippet.find('.row').addClass('d-none');
                sectionsToRemove.forEach((classToRemove) => {
                    mainQuoteRequestForm.find(classToRemove).removeClass('d-none');
                });
                var companyFieldsToDisable = $("[name=company], [name=company_registration_number]");
                var fleetSize = $("[name=fleet_elements]");
                var fleetSiblings = (fleetSize.length>0)? fleetSize.closest('.fields-row').find('.col-12.col-md-6') : null;
                var varNumber = $('[name=vat_number]').closest('.col-12.col-md-6');
                var personalInformation = form.find('.personal-information:not(.static)');
                var taxIdCodeField = $('[name=tax-id-code]').closest('.col-12.col-md-6');
                if (!((typeof fields_labels === undefined) || (typeof fields_labels === "undefined"))){
                    manageCustomLabels($(this).val())
                }
                if (taxIdCodeField.length>0 && varNumber.length>0){
                    var selectedTarget = $(this).val();
                    $('input',varNumber).attr("data-validate-required", (selectedTarget !== 'private'));
                    $('input',varNumber).attr("data-validate-combined", (selectedTarget === 'professional'));
                    $('input',varNumber).attr("data-validate-blocked", (selectedTarget === 'private'));
                    $('input',taxIdCodeField).attr("data-validate-blocked", (selectedTarget !== 'private'));
                    $('input',taxIdCodeField).attr("data-validate-required", (selectedTarget === 'private'));
                    if (selectedTarget === 'corporate'){
                        taxIdCodeField.addClass('d-none')
                    }else{
                        taxIdCodeField.removeClass('d-none')
                    }
                }
                if ($(this).val() === 'private') {
                    form.find(".personal-information .tooltip-button").addClass('d-none');
                    form.find(".company-information .tooltip-button").addClass('d-none');
                    form.find('.company-information .tooltip-button').tooltip('hide');
                    form.find('.personal-information .tooltip-button').tooltip('hide');
                    if (companyFieldsToDisable.length>0){
                        companyFieldsToDisable.first().closest('fieldset').addClass('d-none');
                        $.each(companyFieldsToDisable, function () {
                            $(this).attr("data-validate-required", false).prop("disabled", true).addClass('disabled');
                        });
                    }
                    if (personalInformation.length>0){
                        personalInformation.find(('.row.fields-row')).append(varNumber)
                    }

                    if (taxIdCodeField.length===0 && varNumber.length>0) {
                        showAlternativeLabel(true);
                    }

                    if (fleetSize.length>0){
                        fleetSize.closest('.col-12.col-md-6').addClass("d-none");
                        if (fleetSiblings !== null && fleetSiblings.length<2){
                            fleetSize.closest('.fleet-container').addClass('d-none');
                            fleetSize.prop("disabled", true).attr("data-validate-required", false);
                        }
                    }
                } else {
                    if($(this).val() === 'corporate'){
                        form.find('.company-information .tooltip-button').addClass('d-none');
                        form.find('.company-information .tooltip-button').tooltip('hide');
                        form.find('.personal-information .tooltip-button').addClass('d-none');
                        form.find('.personal-information .tooltip-button').tooltip('hide');
                    }else{
                        form.find(".personal-information .tooltip-button").removeClass('d-none');
                        form.find('.company-information .tooltip-button').removeClass('d-none');
                    }
                    if (companyFieldsToDisable.length>0){
                        companyFieldsToDisable.first().closest('fieldset').removeClass('d-none');
                        $.each(companyFieldsToDisable, function () {
                            $(this).attr("data-validate-required", true).prop("disabled", false).removeClass('disabled');
                        });
                    }
                    if (personalInformation.length>0){
                        var vatNumberToRemove = $(varNumber, personalInformation)
                        if (vatNumberToRemove.length>0){
                            vatNumberToRemove.remove()
                        }
                        form.find('.company-information .fields-row').append(vatNumberToRemove)
                    }

                    if (taxIdCodeField.length===0 && varNumber.length>0) {
                        showAlternativeLabel(false);
                    }

                    if (fleetSize.length>0){
                        fleetSize.closest('.col-12.col-md-6').removeClass("d-none");
                        fleetSize.closest('.fleet-container').removeClass("d-none");
                        fleetSize.prop("disabled", false).attr("data-validate-required", true);
                    }
                }
            }
        });
    }
    function manageCustomLabels(targetSelected) {
        fields_labels.forEach(function (currentElement) {
            var formElementLabel = $("label[for="+currentElement['key']+"-field]")
            if (formElementLabel.length>0){
                formElementLabel.text(currentElement[targetSelected])
            }
        })
    }

    function showAlternativeLabel(showAlternative){

        var vatNumberLabel = $('label.vat-number-label');

        if(showAlternative){
            vatNumberLabel.text(vatNumberLabel.data('alternative-label'))
        } else {
            vatNumberLabel.text(vatNumberLabel.data('standard-label'))
        }
    }



    function showErrors() {
        if ($('.err', form).length) {
            var collapseContainer = $('.offer-page #car-detail-quote-request-collapse-container');
            if (collapseContainer.length) {
                collapseContainer.collapse("show");
                scrollToElementManage.scrollTo(collapseContainer);
            }
            //mainFormCarousel.trigger('to.owl.carousel', $('.err', form).closest('.item.step').attr('data-step'));
        }
    }


    function showHideMainSubmitBtn() {

    }



    function formIsValid() {
        var isValid = true;
        var invalidFields = [];
        var taxIdCode = $('[name=tax-id-code]');

        $("input.form-control, input.form-check-input, select.form-control", form).each(function () {
            var regexPattern = $(this).attr("pattern");
            var validationCombined = $(this).attr("data-validate-combined") === "true"
            var validationBlocked = $(this).attr("data-validate-blocked") === "true"
            if ($(this).attr("data-validate-required") === "false" && !validationCombined && (validationBlocked || !regexPattern)) return;

            var re;
            if (regexPattern) {
                re = new RegExp($(this).attr("pattern"));
            }

            var currentIsValid;

            if (validationCombined){
                var vatNumber = $(this);
                if (vatNumber.attr("data-validate-required") === "true" && vatNumber.val() === '' && taxIdCode.val() === ''){
                    currentIsValid = false;
                }
                else{
                    var vatIsValid = (vatNumber.val() === '') || ((vatNumber.val() !== '') && (!regexPattern || re.test(vatNumber.val())));
                    var taxIdCodeRegex = taxIdCode.attr('pattern');
                    var taxIdCodeIsValid = (taxIdCode.val() === '') || ((taxIdCode.val() !== '') && (!taxIdCodeRegex || new RegExp(taxIdCodeRegex).test(taxIdCode.val())));
                    currentIsValid = vatIsValid && taxIdCodeIsValid;
                }
            }else{
                currentIsValid = (
                    ($(this).attr("type") === "email" && isValidEmail($(this).val())) ||
                    ($(this).attr("type") === "text" && $(this).val() !== '' && (!regexPattern || re.test($(this).val()))) ||
                    ($(this).attr("type") === "number" && $(this).val() !== '') ||
                    ($(this).is("select") && $(this).val() !== '' && $(this).val() !== null) ||
                    ($(this).attr("type") === "radio" && $(this).attr("data-validate-present") === 'true' && $(this).closest('.radio-container').find("input:radio[name='" + this.name + "']").is(":checked")) ||
                    ($(this).attr("type") === "radio" && $(this).is(":checked"))
                );
            }

            //alert($(this).attr("name")+"||"+currentIsValid);

            if ($(this).hasClass("select2-hidden-accessible")) {
                var $select2Container = $(this).next(".select2");
                if ($(this).val() === "" || $(this).val() === null) {
                    currentIsValid = false;
                    $(this).addClass("is-invalid");
                } else {
                    $(this).removeClass("is-invalid");
                }
            }

            isValid = isValid && currentIsValid;


            if (!currentIsValid) {
                var labelText = '';
                if ($(this).attr("type") === "radio" || ($(this).attr("type") === "checkbox")) {
                    $(this).closest(".radio-container").addClass("is-invalid");
                    labelText = $(this).closest('fieldset').find('h4').html();
                } else {
                    $(this).addClass("is-invalid");
                    labelText = $("label[for='" + $(this).attr("id") + "']").text().trim() || $(this).attr("name");
                    if (validationCombined && $(this).attr("name")==='vat_number'){
                        taxIdCode.addClass("is-invalid");
                        labelText = ($("label[for='" + taxIdCode.attr("id") + "']").text().trim() || taxIdCode.attr("name")) + ', ' + labelText
                    }
                }

                labelText = labelText.replace(/\*/g, '').trim();

                if (labelText && !invalidFields.includes(labelText)) {
                    invalidFields.push(labelText);
                }
            } else {
                if ($(this).attr("type") === "radio") {
                    $(this).closest(".radio-container").removeClass("is-invalid");
                } else {
                    $(this).removeClass("is-invalid");
                    if (validationCombined && $(this).attr("name")==='vat_number'){
                        taxIdCode.removeClass("is-invalid");
                    }
                }

                if ($(this).hasClass("select2-hidden-accessible")) {
                    $(this).next(".select2").find(".select2-selection").removeClass("is-invalid");
                }
            }
        });

        if ($(".textareaLike").length) {
            isValid = isValid && true;
        }

        var errorBox = $(".container.form-container-error");
        errorBox.find('.error').html('');
        errorBox.hide();
        if (!isValid && invalidFields.length > 0) {
            var message = `
                    ${invalidFields.map(f => `${f}`).join(', ')}`;
            errorBox.find('.error').html(message);
            errorBox.show();
        }

        return isValid;
    }

    function helper() {
        $('#infoModal').on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget);
            var title = button.data('title');
            var description = button.data('description');
            var modal = $(this);
            modal.find('.modal-title').text(title);
            modal.find('.modal-body p').html(description);
        })
    }

    function initializeForm(){
        if($('.main-quote-request-form select[name="customer_type"]').select2().length > 0){
            if($('.main-quote-request-form select[name="customer_type"]').select2().val() === ''){
                $('.main-quote-request-form select[name="customer_type"]').select2().val('professional');
            }
            $('.main-quote-request-form select[name="customer_type"]').select2().trigger('change');
        }
    }

    return {
        init: init,
        initializeForm: initializeForm
    };
})(jQuery);
(function ($) {
    $('.consent-acc-btn').on('click', function(){
        var $btn = $(this);
        var target = $btn.attr('data-target');
        // Bootstrap gestisce la classe .show; aggiorno aria-expanded
        setTimeout(function(){
            var open = $(target).hasClass('show');
            $btn.attr('aria-expanded', open);
        }, 200);
    });

})(jQuery);
